import React from "react";
import AddIcon from "@mui/icons-material/Add";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";
import CarRepairIcon from "@mui/icons-material/CarRepair";
import MapIcon from "@mui/icons-material/Map";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
//import PaymentIcon from "@mui/icons-material/Payment";

export const SidebarData = [

  {
    title: "Add Parking Lot",
    icon: <AddIcon />,
    link: "/Lots",
    cName: "nav-text",
  },
  {
    title: "Parking Lots",
    icon: <AirportShuttleIcon />,
    link: "/Lots",
    cName: "nav-text",
  },
  {
    title: "List of Spaces",
    icon: <CarRepairIcon />,
    link: "/ParkingSpaces",
    cName: "nav-text",
  },
  {
    title: "Map",
    icon: <MapIcon />,
    link: "./Map",
    cName: "nav-text",
  },
  {
    title: "Reservations",
    icon: <BookOnlineIcon />,
    link: "/Calendar",
    cName: "nav-text",
  },
  // {
  //     title: 'Payment',
  //     icon: <PaymentIcon />,
  //     link: '/',
  //     cName: 'nav-text'
  // },
];

